import React from 'react';
import styles from './skip-navigation.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';

export function SkipNavigation({ onSkip }) {
  const skipToContentLang = useSelector(getLang('ACCESSIBILITY'));

  const handleClick = () => {
    if (onSkip) {
      requestAnimationFrame(() => onSkip());
    }
  };

  return (
    <a href="#main-content" className={styles.skipLink} onClickCapture={handleClick}>
      {skipToContentLang.SKIP_TO_CONTENT}
    </a>
  );
}

export function ReturnToTop({ onSkip }) {
  const skipToContentLang = useSelector(getLang('ACCESSIBILITY'));

  const handleClick = () => {
    if (onSkip) {
      requestAnimationFrame(() => onSkip());
    }
  };

  return (
    <a href="#main-content" className={styles.returnToTop} onClick={handleClick}>
      {skipToContentLang.RETURN_TO_TOP}
    </a>
  );
}
